import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import AdminCareHeader from '../AdminCareHeader'

function ContactHeader() {
    const location = useLocation()
    return (
        <div>
            <AdminCareHeader />
        </div>
    )
}

export default ContactHeader